<template>
<div class="animated fadeIn mt-5">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <div class="col-md-6">
        <b-card>
          <div slot="header">
            <strong>Família</strong>
          </div>
          <b-form-row>
            <b-col md="3">
              <b-form-fieldset label="Código">
                <b-form-input type="text" name="code" v-model="item.code" placeholder="Código"  v-validate="'required'" :state="validateState('code')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('code') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
            <b-col md="9">
              <b-form-fieldset label="Apelido">
                <b-form-input type="text" name="surname" v-model="item.surname" placeholder="Apelido"  v-validate="'required'" :state="validateState('surname')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('surname') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
          </b-form-row>
          <b-form-fieldset label="Email">
            <b-form-input type="email" name="email" v-model="item.email" placeholder="Email" v-validate="{ required: true, email:true }" :state="validateState('email')" data-vv-validate-on="change" ></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('email') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Morada">
            <b-form-input type="text" name="address" v-model="item.address" placeholder="Morada" v-validate="{ required: true }" :state="validateState('address')" data-vv-validate-on="change" ></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('address') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-row>
            <b-col md="4">
              <b-form-fieldset label="Código Postal">
                <b-form-input type="text" name="zip_code" v-model="item.zip_code" placeholder="Código Postal" v-validate="{ required: true }" :state="validateState('zip_code')" data-vv-validate-on="change" ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('zip_code') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
            <b-col md="8">
              <b-form-fieldset label="Localidade">
                <b-form-input type="text" name="locality" v-model="item.locality" placeholder="Localidade" v-validate="{ required: true }" :state="validateState('locality')" data-vv-validate-on="change" ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('locality') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col md="4">
              <b-form-fieldset label="País">
                <b-form-input type="text" name="country_id" v-model="item.country_id" placeholder="País" v-validate="{ required: true }" :state="validateState('country_id')" data-vv-validate-on="change" ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('country_id') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
            <b-col md="8">
              <b-form-fieldset label="Código de Zona">
                <b-form-input type="text" name="zone_code" v-model="item.zone_code" placeholder="Código de Zona" v-validate="{ required: true }" :state="validateState('zone_code')" data-vv-validate-on="change" ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('zone_code') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
          </b-form-row>

          <b-form-fieldset label="Notas / Observações">
            <b-form-textarea type="text" :rows="10" name="notes" v-model="item.notes" placeholder="Notas / Observações" v-validate="{ required: true }" :state="validateState('notes')" data-vv-validate-on="change" ></b-form-textarea>
            <b-form-invalid-feedback>
              {{ errors.first('notes') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>

          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:baseRoute + '.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <!--/.col-->
      <div class="col-md-3">
        <b-card>
          <div slot="header">
            <strong>Estado</strong>
          </div>
          <b-form-fieldset label="Estado">
            <b-form-select v-model="item.state" class="mb-3">
              <option value="0">Bloqueado</option>
              <option value="1">Activo</option>
            </b-form-select>
          </b-form-fieldset>
        </b-card>

      </div>

      <!--/.col-->
    </div>
  </form>

</div>
</template>

<script>
export default {
  name: 'FamiliesEdit',
  props: ['id'],
  data() {
    return {
      url: 'families',
      baseRoute: 'families',
      showTeam: false,
      showPassword: false,
      item: {
        surname: '',
        state: 1,
        email: '',
        code: ''
      }
    }
  },
  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast('Tem campos inválidos', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put(this.url + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
            if (close) {
              this.$router.push({
                name: this.baseRoute + '.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
      } else {
        this.axios.post(this.url, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
            this.$router.push({
              name: this.baseRoute + '.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get(this.url + '/' + id)
        .then(response => {
          this.item = response.data.data
        })
        .catch(response => {          
          this.$bvToast.toast('Esta pessoa não existe', { autoHideDelay: 5000, variant: 'danger', solid: true})
          this.$router.push({
            name: this.baseRoute + '.index'
          })
        })
    } else {
    }
  }
}
</script>
